import { render, staticRenderFns } from "./AdmissionFeesReceipt.vue?vue&type=template&id=741dce4d&scoped=true&"
import script from "./AdmissionFeesReceipt.vue?vue&type=script&lang=js&"
export * from "./AdmissionFeesReceipt.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionFeesReceipt.vue?vue&type=style&index=0&id=741dce4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741dce4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VSimpleTable})
